import { PayloadAction } from "@reduxjs/toolkit";
import { Error } from "../../../../utl/models/Error";
import { EmployeesState } from "../models/EmployeesState";

const setErrorEmailEmployee = (state: EmployeesState, action: PayloadAction<Error>) => {
    state.emailError = action.payload.error;
}

export default setErrorEmailEmployee;